import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React__default, { useMemo } from 'react';
import AriaDialog from './aria/dialog.esm.js';

var _excluded = ["className", "maxWidth", "canShrink", "style"];
function Dialog(_ref) {
  var className = _ref.className,
    maxWidth = _ref.maxWidth,
    _ref$canShrink = _ref.canShrink,
    canShrink = _ref$canShrink === void 0 ? true : _ref$canShrink,
    _style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useMemo(function () {
    return cn('relative flex  w-full flex-col rounded-[inherit] bg-inherit outline-0 print:overflow-visible', {
      'max-h-[inherit] min-h-0 overflow-auto': canShrink,
      'max-w-[--max-dialog-width]': !!maxWidth
    }, className);
  }, [canShrink, className, maxWidth]);
  var style = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, _style), maxWidth ? {
      '--max-dialog-width': "".concat(maxWidth, "px")
    } : {});
  }, [_style, maxWidth]);
  return /*#__PURE__*/React__default.createElement(AriaDialog, _extends({
    className: "csg-tw-dialog ".concat(classes),
    style: style
  }, props));
}

export { Dialog as default };
//# sourceMappingURL=dialog.esm.js.map
